export class TealiumConstants {
	public static readonly TOOLS_EVENT = {
		START: 'tool start event',
		COMPLETION: 'tool completion event',
		GENERIC: 'generic link',
		QUICK_IMPORT: 'quick import',
		EDIT_PORTFOLIO: 'edit portfolio',
		DOWNLOAD: 'download',
		TAX_TOOL_DOWNLOAD: 'tax tool download',
		ERROR: 'error',
		CLIENT_PDF: 'client report',
		ADVISOR_PDF: 'advisor report',
		PROPOSAL_PDF: 'proposal report',
		PS_ADVISOR_PDF: 'ps advisor report',
		CLOSE_REPORT_WINDOW: 'close report window',
		SLIDER: 'slider',
		CREATE_NEW_PORTFOLIO: 'create new portfolio',
		TOOL_TIP: 'tooltip',
		NEW_URL: 'new url',
		NEW_ANALYSIS: 'new analysis',
		YIELD_CHECK_BOX: 'include_yield:',
		PORTFOLIO_EDITOR_DELETE_CHILD: 'editor-right-section:delete button',
		PORTFOLIO_EDITOR_EDIT_CHILD: 'editor-right-section:edit button',
		PORTFOLIO_EDITOR_VIEW_CHILD: 'editor-right-section:view button',
		PORTFOLIO_EDITOR_SELECT_TYPE: 'save-footer:dropdown:',
		PORTFOLIO_EDITOR_SELECT_TYPE_TO_ADD: 'select-portfolio-child:dropdown',
		PORTFOLIO_EDITOR_SAVE_PORTFOLIO: 'save-footer:button:Save Portfolio',
		PORTFOLIO_EDITOR_SAVE_CHILD: 'portfolio-child-view:button:Save:',
		EXCEL_DOWNLOAD: 'Excel download event'
	};

	// Al section/subsection names should be added here if we want to track them
	public static readonly PDF_SECTION_IDS = {
		'INSIGHTS_SECTION_KEY': 'insights',
		'CHARACTERISTICS_SECTION_KEY': 'characteristics',
		'Stock Region': 'subCharsEQ',
		'Credit Quality and Fixed Income Component': 'subCharsFI',
		'Multi-Asset Attributes': 'subCharsMA',
		'Alternative Asset Allocations': 'subCharsAlts',
		'PERFORMANCE_SECTION_KEY': 'performance',
		'RISK_SECTION_KEY': 'risk',
		'Total Portfolio Risk': 'subRiskPort',
		'Equity Deep Dive': 'subRiskEQ',
		'Fixed Income Deep Dive': 'subRiskFI',
		'Alternatives Deep Dive': 'subRiskAlts',
		'Multi-Asset Deep Dive': 'subRiskMA',
		'SCENARIOS_SECTION_KEY': 'scenarios',
		'PEER_COMPARISON_SECTION_KEY': 'cap',
		'MARKET_VIEWS_SECTION_KEY': 'mktViews',
		'HOLDINGS_DETAILS_SECTION_KEY': 'holdingDetails',
		'ESG_SECTION_KEY': 'sustainability'
	};

	public static readonly PDF_CLIENT_PROPOSAL_SECTION_ID_PREFIX = 'SNAPSHOT_REPORT';

	public static readonly DATA_MAPPING = {
		COMPONENT_NAME: 'component_name',
		ERROR_SEVERITY: 'error_severity',
		ENGAGEMENT_ID: 'engagement_Id',
		TRACKED_ERROR_MESSAGE: 'tracked_error_message',
		EXTRA_PARAMS: 'extra_params',
		LINK_NAME: 'link_name',
		LINK_TYPE: 'linkType',
		MODE: 'mode',
		PARAM: 'param',
		PARTNER_NAME: 'partner_name',
		IMPORT_PARTNER_NAME: 'importPartnerName',
		PORTFOLIO_CATEGORY: 'portfolio_category',
		PORTFOLIO_IDS: 'portfolio_Ids',
		REPORT_TYPE: 'report_type',
		TOOL_END_EVENT: 'toolendevent',
		TOOL_FLOW: 'tool_flow',
		TOOL_NAME: 'tool_name',
		TOOL_PARAMS: 'tool_params',
		TOOL_START_EVENT: 'toolstartevent',
		NT_PT_GLOBAL_EXTRA: 'NTPT_GLBLEXTRA',
		INSIGHT: 'insight',
		INCLUDE_YIELD: 'include_yield',
		FTE_MAP: 'fte_map',
		PORTFOLIO_ADDED: 'portfolio_added',
		PORTFOLIO_REMOVED: 'portfolio_removed',
		REPORT_VARS: 'report_vars',
		MODULAR_VARS: 'modular_vars',
		FTE_NEW_PORTFOLIO_ID: 'fte_new_portfolioId',
		DIRTY_PORTFOLIO_ERRORS: 'dirty_portfolio_errors',
		PORTFOLIOS_BREAKDOWN: 'portfolios_breakdown',
		FUND_HEALTH_ANALYSIS_BREAKDOWN: 'fund_health_analysis_breakdown',
		PORTFOLIO_COUNT: 'portfolioCount',
		INVALID_CUSIPS: 'invalidCusips',
		INVALID_TICKERS: 'invalidTickers',
		REPLACEMENT_CUSIPS: 'replacementCusips'
	};

	public static readonly EVENT_NUMBERS = {
		START_EVENT: 'event2',
		COMPLETE_EVENT: 'event3',
		DOWNLOAD_EVENT: 'event50',
		EVENT_51: 'event51',
		EVENT_53: 'event53',
		EVENT_61: 'event61',
		EVENT_62: 'event62',
		EVENT_69: 'event69',
		EVENT_70: 'event70',
		EVENT_72: 'event72',
		EVENT_15: 'event15'
	};

	public static readonly LINK_NAMES = {
		REBALANCE_FILE_DOWNLOADS: 'file downloads',
		ST_RESULTS: 'st results',
		ADD_TO_COMPARE_EVENT: 'add to compare event',
		REMOVE_PORTFOLIO_EVENT: 'remove portfolio event',
		VIEW_360_ANALYSIS_EVENT: 'view 360 analysis event',
		SAVE_PORTFOLIO_EVENT: 'save portfolio event',
		IMPORT_PARTNER_PORTFOLIO_EVENT: 'import partner portfolio event'
	};

	public static readonly TOOL_NAMES = {
		BOND_BUYER_TOOL: 'bond buyer tool',
		SCENARIO_TESTER_TOOL: 'scenario tester tool 2.0',
		PORTFOLIO_ANALYSER_TOOL: '360 evaluator tool',
		PEER_COMPARISON_TOOL: 'peer comparison tool',
		COMPARE_AGAINST_PEERS_TOOL: 'compare against peers',
		CUSTOMIZE_MODELS_TOOL: 'customize models tool',
		TAX_ESTIMATOR_TOOL: 'tax estimator tool',
		MODELS_BROWSE: 'models browse',
		PAC_TOOL: 'bpas',
		PC_TOOL: 'portfolio centre tool',
		PC_DASHBOARD: 'dashboard',
		CMA_ESTIMATOR_TOOL: 'cma estimator',
		IQ_TOOL: 'investment quality tool',
		IRETIRE_ACCUM_TOOL: 'iretire accum tool',
		IRETIRE_DECUM_TOOL: 'iretire decum tool',
		PI_DASHBOARD_TOOL: 'professional investors dashboard tool',
		MODELS_EXPERIENCE: 'models experience',
		AC_PORTFOLIO_LIBRARY: 'ac portfolio library tool',
		MONITORING: 'ac portfolio monitoring'
	};

	public static readonly EVENT_PROPERTY_NAMES = {
		PORTFOLIO_ADDED: 'portfolioAdded',
		PORTFOLIO_REMOVED: 'portfolioRemoved'
	};

	public static readonly PARTNER_EVENTS = {
		CLEAN_IMPORT: 'partner-portfolio-import:clean',
		DIRTY_IMPORT: 'partner-portfolio-import:dirty',
		UNSUPPORTED_DIALOG_VIEW: 'portfolio-error-modal:modal:view',
		UNSUPPORTED_DIALOG_CLOSE: 'partner-porfolio-error-modal:icon:close',
		MODEL_SCREENER_DIALOG_CLOSE: 'choose-replacement:model-screener-modal:icon:close',
		MODEL_TYPE_CHANGE: 'portfolio-export-modal:drop-down:model-type:',
		RISK_CATEGORY_CHANGE: 'portfolio-export-modal:drop-down:risk-category:',
		PORTFOLIO_EXPORT_EDIT_CTA: 'portfolio-export-modal-edit:cta:',
		PORTFOLIO_EXPORT_CREATE_CTA: 'portfolio-export-modal-create:cta:',
		PORTFOLIO_EXPORT_SUCCESS: 'portfolio-export-modal:modal:success',
		PORTFOLIO_EXPORT_FAIL: 'portfolio-export-modal:modal:fail',
		PE_CTA_IMPORT_SECURITIES_MM: 'blend-table:cta:import-securities:mm',
		PE_CTA_IMPORT_SECURITIES_SMA: 'blend-table:cta:import-securities:sma',
		PE_CTA_REPLACE_WITH_CASH: 'blend-table:cta:replace-with-cash',
		PE_CTA_ADJUST_MODEL: 'blend-table:cta:adjust-model',
		PE_CTA_CHOOSE_REPLACEMENT: 'blend-table:cta:choose-replacement'
	};

	public static readonly MODELS_EXPERIENCE_EVENTS = {
		PILL_DESELECT_ALL: 'button:deselect all', // used within models screener
		MODELS_EXPERIENCE_APP_NAME: 'models-experience',
		FIND_AND_COMPARE_PAGE: 'find and compare',
		FAMILY_DETAILS: 'family details',
		MODELS_HOME_PAGE: 'models home',
		HOW_TO_INVEST: 'how to invest',
		COMPARE: 'compare',
		DOWNLOAD_HOLDINGS: 'downloadHoldings',
		ADDITIONAL_DETAILS: 'additionalDetails'
	};

	public static readonly MODELS_EXPERIENCE_SUB_SUB_SECTION_NAMES = {
		FAMILY_DETAILS: 'family details',
		FUND_PERFORMANCE: 'fund performance'
	};

	public static readonly MODELS_DIALOG = {
		MODELS_WIDGET: 'models-widget:',
		TAB: 'tab:',
		MY_PORTFOLIOS: 'My Portfolios',
		BLK_MODELS: 'BlackRock Models'
	};

	public static IMPORT_PARTNER_PORTFOLIO_EVENTS = {
		PARTNER_AUTHENTICATION: 'partner authentication:',
		WORKFLOW_ABANDONMENT: 'workflow abandonment',
		INVALID_SECURITIES: 'invalid securities',
		PORTFOLIO_REFRESH: 'portfolio refresh',
		NEW_PARTNER_PORTFOLIO_IMPORT: 'new partner portfolio import',
		SECURITY_REPLACEMENTS: 'security replacements'
	};
}
